import { isEmpty } from 'lodash';
import React, { useMemo, useState } from 'react';

import { PersonOutlined } from '@mui/icons-material';
import { Avatar, Button, Grid, Stack } from '@mui/material';

import useIsMobile from 'hooks/use-is-mobile';
import Pagination from 'pages/Bulletin/components/Pagination';
import { DEFAULT_PAGE_SIZE, PAGE_SIZES } from 'pages/Bulletin/constants';
import ProtectedData, { isProtectedData, UNKNOWN } from 'pages/components/ProtectedData';

import useStyles from './styles';

interface Props {
    data: {
        author: string;
        avatar: string;
        link: string;
        text: string;
    }[];
}

const SocialReferences: React.FC<Props> = ({ data }) => {
    const { classes } = useStyles();
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
    const isMobile = useIsMobile();
    const slice = useMemo(() => data.slice(page * pageSize, (page + 1) * pageSize), [data, page, pageSize]);

    if (isEmpty(data)) {
        return null;
    }

    return (
        <div className={classes.root}>
            <Grid container spacing={isMobile ? '8px' : '16px'}>
                {slice.map(({ author, avatar, link, text }, index) => (
                    <Grid key={index} item xs={12} md={6}>
                        <a
                            className={classes.post}
                            {...(isProtectedData(link)
                                ? {}
                                : {
                                      href: link,
                                      target: '_blank',
                                      rel: 'nofollow noreferrer noopener'
                                  })}
                        >
                            <Stack flexDirection={'row'} alignItems={'center'}>
                                <ProtectedData data={avatar} rounded>
                                    {({ isProtected, content }) =>
                                        isProtected ? (
                                            <Avatar>
                                                <PersonOutlined color="action" />
                                            </Avatar>
                                        ) : (
                                            <Avatar src={content} />
                                        )
                                    }
                                </ProtectedData>
                                <ProtectedData data={author}>
                                    {({ content }) => <p className={classes.author}>{content}</p>}
                                </ProtectedData>
                            </Stack>

                            <ProtectedData data={text}>
                                {({ content }) => <p className={classes.text}>{content}</p>}
                            </ProtectedData>

                            <ProtectedData data={link}>
                                {({ isProtected }) => (
                                    <Button
                                        className={classes.source}
                                        variant="contained"
                                        {...(isProtected
                                            ? { children: UNKNOWN, disabled: true }
                                            : { children: new URL(link).hostname })}
                                    />
                                )}
                            </ProtectedData>
                        </a>
                    </Grid>
                ))}
            </Grid>
            <Pagination
                hidden={data.length < Math.min(...PAGE_SIZES)}
                count={data.length}
                page={page}
                pageSize={pageSize}
                pageOptions={PAGE_SIZES}
                onPageChange={setPage}
                onPageSizeChange={setPageSize}
            />
        </div>
    );
};

export default SocialReferences;
